const filtersRootEl = document.getElementById('collectionFilters');
const compatibilityFilter = {
    data() {
        return {
            open: true,
            compatible: false
        }
    },
    inject: ['isMounted'],
    emits: ['onCompatibilityChange'],
    computed: {
        myCars() {
            return store.getters['garage/cars'];
        },
        activeCar() {
            return store.getters['garage/active'];
        },
        activeCarLabel() {
            if(this.activeCar) {
                return (this.activeCar.name && this.activeCar.name !== '') ? this.activeCar.name : this.activeCar.year + ' ' + this.activeCar.model;
            }
        },
    },
    methods: {
        onChange() {
            this.$emit('onCompatibilityChange', this.compatible);
        },
        addTesla() {
            const teslaEvent = new CustomEvent('open.tesla.popup');
            window.dispatchEvent(teslaEvent);
        }
    },
    template: `<teleport to="#compatFilter" v-if="isMounted"><div class="filter__item toggle_filter">
              <input type="checkbox" id="compat-filter-toggle" class="sr-only" v-model="open">
              <label for="compat-filter-toggle">Compatibility</label>
              <div class="filter__content">
                <span v-if="activeCar">Only show products that fit {{activeCarLabel}}</span>
                <a href="#" @click.prevent="addTesla" v-else>Add your Tesla</a>
                <input id="compatibility" type="checkbox" v-model="compatible" @change="onChange" :disabled="!activeCar"/>
                <label for="compatibility"></label>
              </div>
            </div></teleport>`
}
const filtersApp = Vue.createApp({
    components: {
        'compatibility': compatibilityFilter
    },
    data() {
        return {
            loading: false,
            compatible: false,
            isMounted: false,
        }
    },
    props: ['baseUrl'],
    provide() {
        return {
            isMounted: Vue.computed(() => this.isMounted),
        }
    },
    created() {
    },
    mounted() {
        setTimeout(() => {
            this.isMounted = true;
        },250);
    },
    computed: {
    },
    methods: {
        onCompatibilityChange(compatible) {
            this.loading = true;
            this.compatible = compatible;
            $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
            if(this.compatible === true) {
                document.querySelectorAll('[data-load-more--grid-item][data-product-fits="no"]').forEach((item) => {
                    item.classList.add('hidden');
                });
            } else {
                document.querySelectorAll('[data-load-more--grid-item]').forEach((item) => {
                    item.classList.remove('hidden');
                });
            }
            this.loading = false;
            $('.collection-matrix').removeClass('fadeOut animated loading-in-progress');
        }
    }
}, { ...filtersRootEl.dataset })
filtersApp.use(tesbrosPlugin).use(store);
filtersApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('swatches') && !tag.includes('vueper')
filtersApp.config.unwrapInjectedRef = true
filtersApp.mount('#collectionFilters');
